export default __webpack_public_path__ + "static/media/Iconly-Bulk-Calling.cab2ab43.svg";